import { combineReducers } from "@reduxjs/toolkit";
import listingReducer from "./listingReducer";

const reducer = combineReducers({
  listing: listingReducer,
});

export { reducer };
